import './styles.scss'
import React from 'react'

import { lang } from 'utils/helpers'

const TemplateFreeTextVariable = ({
  template,
  templateVars,
  selectedTemplateVariables,
  handleFreeTextVariables
}) => {
  if (!template.variables.length) {
    return (
      <p
        className='conversation-template-editor__info-text'
      >
        {lang('dashboard_no-variables')}
      </p>
    )
  }

  return template.variables.map((variable, index) => {
    if (variable.field) return null

    return (
      <input
        key={index}
        className={`
            conversation-template-editor__variable-input
            ${variable.field ? 'conversation-template-editor__variable-input--disabled' : ''}
          `}
        type='text'
        disabled={variable.field ? true : false}
        placeholder={variable.name}
        value={variable.field
          ? lang(templateVars.find(variableData => variableData.value === variable.field).label)
          : selectedTemplateVariables?.[index]?.value || ''
        }
        onChange={({ target: { value } }) => handleFreeTextVariables({ index, value })}
      />
    )
  })
}

export default TemplateFreeTextVariable
